import { TRenderable } from "source/app/presentation/Shared/SharedTypes";

export interface IQuickJournalEntry {
    text: TRenderable;
    timeStamp: string;
    createdAt?: string;
}

export interface IQuickJournalState {
    draft: string;
    recentEntries: Array<IQuickJournalEntry | TRenderable>;
    weeklyHourlyCounts: Record<string, number>;
    horizontalOffset: number;
    animatingEntryCreatedAt?: string[];
}

export interface IQuickJournalStoredSnapshot {
    recentEntries: IQuickJournalEntry[];
    dailyCounts: Record<string, number>;
    weeklyHourlyCounts: Record<string, number>;
}

export interface IQuickJournalStats {
    dailyCounts: Record<string, number>;
    weeklyHourlyCounts: Record<string, number>;
}

export const numPrevItemsToShow = 22;
export const quickJournalRecentEntriesStorageKey = "quickJournal_recentEntries";
export const quickJournalSyncedEntriesKey = "QuickJournal_recentEntries";
export const quickJournalSyncDebounceInMilliseconds = 750;
export const quickJournalSyncIntervalInMilliseconds = 15000;
export const latestJournalEntryFadeInDurationInMilliseconds = 650;
export const historicalRowFadeInStaggerInMilliseconds = 45;
export const historicalRowsFadeInTotalDurationInMilliseconds =
    latestJournalEntryFadeInDurationInMilliseconds +
    numPrevItemsToShow * historicalRowFadeInStaggerInMilliseconds;
export const basePrevItemsToShow = 8;
export const recentEntryRowHeight = 28;
export const recentEntryHeightOffset =
    (numPrevItemsToShow - basePrevItemsToShow) * recentEntryRowHeight;
export const quickJournalHeatmapHours = 24;
export const quickJournalHeatmapRows = 7;
